import update from 'react-addons-update';

import { reorderFormList } from '~/utils';

import {
  ADD_FORM_CARD_ORIGINAL_INDEX,
  RESET_REDUX_STORE,
  CHANGE_FORM_CARD_POSITION_ORIGINAL_INDEX,
  ADD_QUESTION_TEXT,
  ADD_FORM_CARD_DATA_DB,
  ADD_FORM_CARD_QUESTION_DATA,
  DELETE_FORM_CARD_DATA_BY_KEY,
  ADD_REF_VALUES_BY_KEY,
  ADD_REF_VALUE_ACTION,
  REORDER_FORM_CARDS_R,
} from '../types/formCard';

export const formCardReducer = (state = [], action) => {
  switch (action.type) {
    case ADD_FORM_CARD_ORIGINAL_INDEX:
      return addFormCardOriginalIndex(state, action);
    case RESET_REDUX_STORE:
      return (state = []);
    case CHANGE_FORM_CARD_POSITION_ORIGINAL_INDEX:
      return changeFormCardPositioninOriginalIndArray(state, action);
    case ADD_QUESTION_TEXT:
      return addQuestionText(state, action);
    case ADD_FORM_CARD_DATA_DB:
      return addFormCardsDataDb(state, action);
    case ADD_FORM_CARD_QUESTION_DATA:
      return addFormCardData(state, action);
    case DELETE_FORM_CARD_DATA_BY_KEY:
      return deleteFormCard(state, action);
    case ADD_REF_VALUES_BY_KEY:
      return addRefvalues(state, action);
    case ADD_REF_VALUE_ACTION:
      return addAction(state, action);
    case REORDER_FORM_CARDS_R: {
      const { index, direction, form_block_id } = action;
      const formList = state[0]['form_block_data_' + form_block_id];
      const newList = reorderFormList(formList, index, direction);
      state[0]['form_block_data_' + form_block_id] = [...newList];
      return [...state];
    }
    default:
      return state;
  }
};

function addFormCardOriginalIndex(state, action) {
  const originalFormCardIndex = action.payload.originalFormCardIndex;
  const form_block_id = action.payload.form_block_id;
  const data = {
    originalFormCardIndex: originalFormCardIndex,
    form_block_id: form_block_id,
  };

  if (state.length == 0) {
    return [...state, { ['original_index_array_' + form_block_id]: [data] }];
  }
  if (['original_index_array_' + form_block_id] in state[0]) {
    return update(state, {
      0: { ['original_index_array_' + form_block_id]: { $push: [data] } },
    });
  }
  return update(state, {
    0: { $merge: { ['original_index_array_' + form_block_id]: [data] } },
  });
}

function changeFormCardPositioninOriginalIndArray(state, action) {
  const { index, changedIndex, form_block_id } = action.payload;
  const ori_array = state[0]['original_index_array_' + form_block_id];
  const removedItem = ori_array.splice(changedIndex, 1);
  ori_array.splice(index, 0, removedItem[0]);
  return [...state];
}

function addQuestionText(state, action) {
  const { stateKey, isLoading } = action.payload;
  if (state.length != 0) {
    return update(state, { 0: { $merge: { [stateKey]: isLoading } } });
  }
  return [...state, { [stateKey]: isLoading }];
}

function addFormCardsDataDb(state, action) {
  const { data, form_block_id } = action.payload;
  let result = [];
  data.forEach((card, index) => {
    if (index == 0) {
      return (result = [
        {
          ['form_block_data_' + form_block_id]: [
            {
              question_id: card.question_id,
              ques_prompt: card.ques_prompt,
              ques_name: card.ques_name,
              answer_entity_id: card.answer_entity_id,
              ques_order: card.ques_order,
              branches: card.branches,
              entity_type:
                card.branches !== undefined && card.branches.length > 0
                  ? 1
                  : card.sys_values !== undefined
                    ? card.sys_values.target_form_block_id
                      ? 2
                      : card.sys_values.target_intent_id
                        ? 3
                        : 0
                    : card.target_form_block_id
                      ? 2
                      : card.target_intent_id
                        ? 3
                        : 0,
              sys_values:
                card.sys_values === undefined
                  ? card.target_form_block_id
                    ? { target_form_block_id: card.target_form_block_id }
                    : { target_intent_id: card.target_intent_id }
                  : card.sys_values,
              cust_attr_id: card.cust_attr_id,
            },
          ],
        },
      ]);
    }
    result = update(result, {
      0: {
        ['form_block_data_' + form_block_id]: {
          $push: [
            {
              question_id: card.question_id,
              ques_prompt: card.ques_prompt,
              ques_name: card.ques_name,
              answer_entity_id: card.answer_entity_id,
              ques_order: card.ques_order,
              branches: card.branches,
              entity_type:
                card.branches !== undefined && card.branches.length > 0
                  ? 1
                  : card.sys_values !== undefined
                    ? card.sys_values.target_form_block_id
                      ? 2
                      : card.sys_values.target_intent_id
                        ? 3
                        : 0
                    : card.target_form_block_id
                      ? 2
                      : card.target_intent_id
                        ? 3
                        : 0,
              sys_values:
                card.sys_values === undefined
                  ? card.target_form_block_id
                    ? { target_form_block_id: card.target_form_block_id }
                    : { target_intent_id: card.target_intent_id }
                  : card.sys_values,
              cust_attr_id: card.cust_attr_id,
            },
          ],
        },
      },
    });
  });
  return result;
}

function addFormCardData(state, action) {
  const { ques_index, data, keyName, form_block_id } = action.payload;
  const buttonKey = ['form_block_data_' + form_block_id];
  if (buttonKey in state[0]) {
    if (state[0][buttonKey].length == ques_index) {
      return update(state, {
        0: { [buttonKey]: { $push: [{ [keyName]: data }] } },
      });
    }
    return update(state, {
      0: {
        [buttonKey]: { [ques_index]: { $merge: { [keyName]: data } } },
      },
    });
  }
  return update(state, {
    0: { $merge: { [buttonKey]: [{ [keyName]: data }] } },
  });
}

function addRefvalues(state, action) {
  const { ques_index, originalFormCardIndex, data, form_block_id } =
    action.payload;
  const buttonKey = ['form_block_data_' + form_block_id];
  state[0][buttonKey][originalFormCardIndex].branches[ques_index] = data;
  return [...state];
}

function deleteFormCard(state, action) {
  const { index, form_block_id } = action.payload;
  if (state.length != 0) {
    if (
      typeof state[0]['form_block_data_' + form_block_id] !== 'undefined' &&
      state[0]['form_block_data_' + form_block_id].length ===
        state[0]['original_index_array_' + form_block_id].length
    ) {
      state[0]['form_block_data_' + form_block_id].splice(index, 1);
    }
    state[0]['original_index_array_' + form_block_id].splice(index, 1);
  }
  return [...state];
}

function addAction(state, action) {
  const { data, ques_index, btn_index, form_block_id } = action.payload;
  const buttonKey = ['form_block_data_' + form_block_id];
  state[0][buttonKey][ques_index]['branches'].splice(btn_index, 1, data);
  return [...state];
}
